export default __webpack_public_path__ + "static/media/50.eb7a93d0.png";